import { useState, useEffect, useRef } from "react";
import './assets/styles/ImageModal.css';

const EditImageModal = ({ show, onClose, petId, currentImageUrl, handleUpload }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(currentImageUrl);
    const fileInputRef = useRef(null); // Ref for file input

    useEffect(() => {
        if (show) {
            setSelectedFile(null); // Clear selected file when opening
            setPreviewUrl(currentImageUrl); // Reset preview to current pet image
            if (fileInputRef.current) {
                fileInputRef.current.value = ""; // Reset file input field
            }
        }
    }, [show, petId]); // Reset whenever modal opens or petId changes

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            setPreviewUrl(URL.createObjectURL(file));
        }
    };

    const handleClose = () => {
        onClose(); // Close modal
    };

    return show ? (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Upload New Image</h3>
                {previewUrl && <img src={previewUrl} alt="Preview" style={{ maxWidth: "150px", maxHeight: "150px" }} />}
                <input type="file" ref={fileInputRef} onChange={handleFileChange} />
                <button onClick={() => handleUpload(petId, selectedFile)} disabled={!selectedFile}>
                    Upload Image
                </button>
                <button onClick={handleClose}>Cancel</button>
            </div>
        </div>
    ) : null;
};

export default EditImageModal;
